/** Minimum length aligned with Firebase-friendly rules (stricter than legacy 6-char). */
export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_REQUIREMENTS_HINT =
  `At least ${PASSWORD_MIN_LENGTH} characters, with one letter and one number.`;

const COMMON_PASSWORDS = new Set([
  'password',
  'password1',
  'password12',
  'password123',
  '12345678',
  '123456789',
  'qwerty123',
  'letmein1',
  'welcome1',
  'iloveyou1',
  'admin123',
  'changeme',
  'changeme1',
]);

/**
 * @param {string} password
 * @returns {{ ok: true } | { ok: false, message: string }}
 */
export function validatePassword(password) {
  const p = String(password || '');
  if (p.length < PASSWORD_MIN_LENGTH) {
    return { ok: false, message: `Password must be at least ${PASSWORD_MIN_LENGTH} characters.` };
  }
  if (!/[a-zA-Z]/.test(p)) {
    return { ok: false, message: 'Password must include at least one letter.' };
  }
  if (!/[0-9]/.test(p)) {
    return { ok: false, message: 'Password must include at least one number.' };
  }
  if (COMMON_PASSWORDS.has(p.toLowerCase())) {
    return { ok: false, message: 'Please choose a less common password.' };
  }
  return { ok: true };
}
